import { Component, Input } from '@builder.io/sdk';

import { moleculeHeadingFields } from 'molecules/Heading/config';
import sectionFields from 'molecules/Section/config';

import { idField } from 'utils/builder/fields';

const metricItemFields = [
  idField,
  {
    name: 'value',
    type: 'string',
    defaultValue: '100%',
    helperText: 'Main numeric value or percentage for this metric (e.g., 100%, 250+, $1M).',
  },
  {
    name: 'heading',
    type: 'string',
    defaultValue: 'Metric Heading',
    helperText: 'Short title that describes the metric (e.g., Customers, Revenue, Uptime).',
  },
  {
    name: 'description',
    type: 'longText',
    defaultValue: 'Description goes here.',
    helperText: 'Optional supporting text that provides more context about the metric.',
  },
] as const satisfies DeepReadonly<Input[]>;

const metricListFields = [
  {
    name: 'metrics',
    type: 'list',
    subFields: metricItemFields,
    helperText: 'Add one or more metrics to display in the section.',
  },
] as const satisfies DeepReadonly<Input[]>;

const metricsFields = [...moleculeHeadingFields, ...sectionFields, ...metricListFields] as const satisfies DeepReadonly<
  Input[]
>;

export const metricsConfig = {
  name: 'metrics',
  inputs: metricsFields,
} satisfies Component;

export type MetricsConfigProps = GenerateBuilder<typeof metricsFields>;
